module.exports = __webpack_public_path__ + "static/media/da-about-3.8bde4c59.jpg";